export const FOUNDERS_ONLY_EVENT_URL = 'https://foundersonly.com.br';
export const FOUNDERS_ONLY_COUPON_CODE = 'KORZA15';
export const FOUNDERS_ONLY_EVENT_END_DATE = new Date(
  '2026-08-29T23:59:59-03:00'
);

export function isFoundersOnlyEventActive(): boolean {
  return new Date() <= FOUNDERS_ONLY_EVENT_END_DATE;
}
